export const SITE_NAME = "PxB Playground";
export const SITE_VER = "act.0";
export const PROJECT_EXT = "pxbp";
export const USER_DATA_STORE_KEY = "pxbp_userData_v1";


// WEBPACK FOOTER //
// ./src/Const.js